import React, { useEffect, useState } from "react";
import cssClasses from "../KYCAgreementForm.module.css";
import Button from "../../../Subcomponents/Button";
import { DataGrid } from "@mui/x-data-grid";
import { dataGridStyles } from "../BankDetails/BankDetails";
import EditIcon from "../../../Assets/Images/Common/EditIcon.svg";
import EmptyState from "../../../Assets/Images/Common/noProjectFound.svg";
import { dismissLoader, presentLoader } from "../../../Services/loader";
import * as XLSX from "xlsx";
import { errorTost, successTost } from "../../../Services/Toast";
import { getAllNbfcDetails, updateNbfcDetails } from "../../../Services/Bank";
import UploadNbfcDetailModal from "../UploadNbfcDetailModal/UploadNbfcModal";
import EditNbfcModal from "../EditNbfcModal/EditNbfcModal";
import _ from "lodash";

const NBFCDetails = () => {
  const [allNbfcData, setAllNbfcData] = useState([]);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [uploadedData, setUploadedData] = useState([]);
  const [selectedNbfcData, setSelectedNbfcData] = useState(null);
  const [showEditNbfcModal, setShowEditNbfcModal] = useState(false);
  const tagGridColumns = [
    {
      field: "action",
      headerName: "",
      width: window.innerWidth < 820 ? 50 : 100,
      renderCell: (params) => {
        return (
          <div style={{ cursor: "pointer" }}>
            <img
              src={EditIcon}
              alt="edit"
              onClick={() => {
                setSelectedNbfcData(params?.row);
                setShowEditNbfcModal(true);
              }}
            />
          </div>
        );
      },
    },
    {
      field: "nbfcName",
      headerName: "NBFC Name",
      width: window.innerWidth < 820 ? 160 : 250,
      renderCell: (params) => {
        return <div>{params?.row?.nbfcName}</div>;
      },
    },
  ];

  useEffect(() => {
    if (allNbfcData?.length === 0) {
      presentLoader();
      getFilterNbfcPagination();
    }
  }, []);

  const getFilterNbfcPagination = () => {
    getAllNbfcDetails()
      .then((resp) => {
        dismissLoader();
        setAllNbfcData(
          resp?.data?.map((val) => {
            return { ...val, id: val?.nbfcId };
          })
        );
      })
      .catch((err) => {
        dismissLoader();
        errorTost(err.message);
      });
  };

  async function downloadExcelTemplate() {
    presentLoader();
    let _list = [{ "NBFC Name": "" }];
    const worksheet = XLSX.utils.json_to_sheet(_list);
    const wscols = [{ wch: 25 }];
    worksheet["!cols"] = wscols;
    const workBook = new XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, worksheet, "Price list Units");
    XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    XLSX.writeFile(workBook, `NBFC_Template.xlsx`);
    dismissLoader();
  }

  async function downloadExcelList() {
    presentLoader();
    let _list = allNbfcData?.map((v) => {
      return { "NBFC Name": v?.nbfcName };
    });
    const worksheet = XLSX.utils.json_to_sheet(_list);
    const wscols = [{ wch: 25 }];
    worksheet["!cols"] = wscols;
    const workBook = new XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, worksheet, "Price list Units");
    XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    XLSX.writeFile(workBook, `NBFC_List.xlsx`);
    dismissLoader();
  }

  function openSelectExcelFile() {
    let htmlElement = document.createElement("input");
    htmlElement.type = "file";
    htmlElement.accept =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel";
    htmlElement.multiple = false;
    htmlElement.click();
    htmlElement.onchange = onChangeSelectExcel;
  }

  function onChangeSelectExcel(e) {
    if (
      spreadExtension?.findIndex((i) => i === e?.target?.files[0].type) !== -1
    ) {
      presentLoader();
      let _file = e.target.files[0];
      if (_file) {
        const reader = new FileReader();
        reader.onload = function (e) {
          var data = e.target.result;
          data = new Uint8Array(data);
          var workbook = XLSX.read(data, {
            type: "array",
            cellText: false,
            cellDates: true,
          });
          var roa;
          workbook.SheetNames.forEach(function (sheetName) {
            roa = XLSX.utils.sheet_to_row_object_array(
              workbook.Sheets[sheetName],
              { raw: false, dateNF: "yyyy-mm-dd" }
            );
          });

          const obj = roa?.map((v) => {
            return { nbfcName: v?.["NBFC Name"] };
          });

          setUploadedData(obj);
          dismissLoader();
          setShowUploadModal(true);
        };
        reader.readAsArrayBuffer(_file);
      } else {
        dismissLoader();
        errorTost("Please select valid excel file.");
      }
    } else {
      errorTost("Please select valid excel file.");
    }
  }

  const handleEditNbfcDetails = (val) => {
    presentLoader();
    const payload = {
      nbfcName: val?.nbfcName,
      last_updated_at: new Date().getTime(),
    };
    updateNbfcDetails(payload, selectedNbfcData?.nbfcId)
      .then((resp) => {
        dismissLoader();
        successTost("NBFC name updated successfully!");
        setSelectedNbfcData(null);
        getFilterNbfcPagination();
      })
      .catch((err) => {
        dismissLoader();
        setSelectedNbfcData(null);
        errorTost(err.message);
      });
  };
  return (
    <>
      <div className={cssClasses.wrapperSubContent}>
        <div className={cssClasses.ndfcButtonGroup}>
          <Button
            style={{
              color: "#000",
              backgroundColor: "rgba(255, 255, 255, 1)",
              fontSize: "1.6rem",
              lineHeight: "2.4rem",
              width: "17rem",
            }}
            btnName={"Download List"}
            clicked={() => {
              downloadExcelList();
            }}
          />
          <Button
            style={{
              color: "#000",
              backgroundColor: "rgba(255, 255, 255, 1)",
              fontSize: "1.6rem",
              lineHeight: "2.4rem",
              width: "21rem",
            }}
            btnName={"Download Template"}
            clicked={() => {
              downloadExcelTemplate();
            }}
          />
          <Button
            style={{
              color: "#FFFFFF",
              backgroundColor: "#155EEF",
              fontSize: "1.6rem",
              lineHeight: "2.4rem",
              width: "17rem",
            }}
            btnName={"Upload CSV"}
            clicked={() => {
              openSelectExcelFile();
            }}
          />
        </div>
        <div style={{ margin: "1rem" }}>
          {allNbfcData?.length > 0 ? (
            <DataGrid
              rows={allNbfcData}
              columns={tagGridColumns}
              hideFooterPagination={false}
              hideFooter={false}
              pageSize={10}
              rowsPerPageOptions={[10]}
              sx={[dataGridStyles]}
              disableColumnFilter
              disableColumnMenu
              disableColumnSelector
              disableDensitySelector
              disableSelectionOnClick
              disableVirtualization
            />
          ) : (
            <div style={{ height: "400px" }}>
              <p
                style={{
                  position: "relative",
                  top: "50%",
                  textAlign: "center",
                  fontSize: "3rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <img src={EmptyState} alt="No Data" />
                  <span>No Record Available</span>
                </div>
              </p>
            </div>
          )}
        </div>
        {showUploadModal && (
          <UploadNbfcDetailModal
            open={showUploadModal}
            handleClose={() => {
              setShowUploadModal(false);
              presentLoader();
              getFilterNbfcPagination();
            }}
            selectedData={uploadedData}
            allNbfcData={allNbfcData}
          />
        )}
      </div>
      {showEditNbfcModal && (
        <EditNbfcModal
          open={showEditNbfcModal}
          handleClose={() => {
            setShowEditNbfcModal(false);
            getFilterNbfcPagination();
          }}
          selectedNbfcData={selectedNbfcData}
          allNbfcList={_.cloneDeep(allNbfcData)}
          handleSave={(val) => {
            setShowEditNbfcModal(false);
            handleEditNbfcDetails(val);
          }}
        />
      )}
    </>
  );
};

let spreadExtension = [
  "application/excel",
  "application/vnd.ms-excel",
  "application/x-excel",
  "application/x-msexcel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.oasis.opendocument.spreadsheet",
];

export default NBFCDetails;
